import { InvestmentAccountType } from "../../../../lib/proto/investment_accounts";
import { Cadence } from "../../../../lib/proto/time";

// Potential Component Constants
export const ACCT_TYPES_QUESTIONS = [
    InvestmentAccountType.ira.id,
    InvestmentAccountType.rollover_ira.id,
    InvestmentAccountType.sepp_ira.id,
    InvestmentAccountType.simple_ira.id,
];
  
export const ACCT_TYPE_TO_ID = {
    [InvestmentAccountType.ira.id]: "type",
    [InvestmentAccountType.rollover_ira.id]: "type1",
    [InvestmentAccountType.sepp_ira.id]: "type2",
    [InvestmentAccountType.simple_ira.id]: "type2",
    [InvestmentAccountType.roth_ira.id]: "type3",
  
    // Taxable
    [InvestmentAccountType.individual.id]: "type4",
    [InvestmentAccountType.joint.id]: "type4",
    [InvestmentAccountType.ugma_utma.id]: "type4",
    [InvestmentAccountType.a_529.id]: "type4",
    [InvestmentAccountType.corporate.id]: "type4",
    [InvestmentAccountType.partnership.id]: "type4",
}
  
export const CADENCE_TO_ID = {
    [Cadence]: 52,
    [Cadence.monthly.id]: 12,
    [Cadence.quarterly.id]: 4,
    [Cadence.annually.id]: 1,
}

export const FREQUENCY = Object.freeze({
    ANNUALLY: 1,
    BI_MONTHLY: 6,
    BI_WEEKLY: 26,
    DAILY: 365,
    MONTHLY: 12,
    QUARTERLY: 4,
    SEMI_ANNUALLY: 2,
    SEMI_MONTHLY: 24,
    WEEKLY: 52
})

export const CADENCE = Object.freeze({
    WEEKLY: 52,
    MONTHLY: 12,
    QUARTERLY: 4,
    ANNUALLY: 1
})

export const DEFAULT_IRR = 6;

export const ROTH_IRA_INVESTMENT_YEAR_TEXT = 'This is how many more years until you turn 59 1⁄2 and can start taking penalty free distributions';
export const ROTH_IRA_POTENTIAL_AMOUNT_TEXT = 'This is the potential value of this portfolio when you turn 59 1/2';

export const IRA_INVESTMENT_YEAR_TEXT = 'This is how many more years until you turn 72 1⁄2 and will be required by the IRS to take Minimum Distributions from this account';
export const IRA_POTENTIAL_AMOUNT_TEXT = 'This is the potential value of your portfolio when you turn 72 1/2';
export const IRA_DISTRIBUTION_YEAR_TEXT = 'This is how many years the IRS requires you to take distributions starting at age 72 1/2';

export const UGMA_INVESTMENT_YEAR_TEXT = 'This is how many more years until the child hits their age of majority and takes ownership of the account';
export const UGMA_POTENTIAL_AMOUNT_TEXT = 'This is the potential value of this portfolio when the account hits the child’s age of majority';

export const INDIVIDUAL_INVESTMENT_YEAR_TEXT = 'This is your investment horizon or how many more years you wanted to invest for';
export const INDIVIDUAL_POTENTIAL_AMOUNT_TEXT = 'This is the potential value of your portfolio upon reaching your investment horizon';
export const INDIVIDUAL_DISTRIBUTION_TEXT = 'Number of years you wanted to receive funds after reaching your investment horizon';